export const DETAILS_INPUT: any =
{
    Paused: {
        info: 'This will temporarily stop all deduction related to this product.',
        dateLabel: 'Paused Date',
        radio: [
            {label: 'Manual Resume', value: 'Manual', disabled: false},
            {label: 'Scheduled Resume', value: 'Scheduled', disabled: true}
        ],
        reason: [
                    {name: 'Natural Calamity (e.g., Typhoon, Flooding)'},
                    {name: 'Driver Request'},
                    {name: 'Medical Leave / Health-Related'},
                    {name: 'Vehicle Accident / Repair'},
                    {name: 'Temporary Relocation'},
                    {name: 'Suspension of Operations (e.g., area lockdown)'},
                    {name: 'Pending Investigation / Review'},
                    {name: 'System Error / Technical Issue'},
                    {name: 'Others'}
        ]
    },

    Resume: {
        info: 'Restarting this program will lift the deduction hold and resume scheduled payments immediately.',
        dateLabel: 'Resume Date',
        radio: [
            {label: 'Extended Payment Period', value: 'extended', disabled: false},
            {label: 'Catch-up Payments', value: 'catchup', disabled: true},
            {label: 'Pay Missed Dues in Full', value: 'payfull', disabled: true}
        ],
        reason: [
                    {name: 'Recovery from Natural Calamity'},
                    {name: 'Driver Request'},
                    {name: 'Medical Leave / Health Recovery'},
                    {name: 'Vehicle Repaired / Available for Use'},
                    {name: 'Returned from Temporary Relocation'},
                    {name: 'Operations Resumed'},
                    {name: 'Cleared from Pending Investigation / Review'},
                    {name: 'Resolved System Error / Technical Issue'},
                    {name: 'Others'}
        ]
    }
};
